import React from 'react'

export default ({ fill, width, height }) => {
  return (
    <svg
      width={width || '20'}
      height={height || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.75 11.875C13.375 11.875 13.125 11.625 13.125 11.25V0.625C13.125 0.25 13.375 0 13.75 0H18.75C19.125 0 19.375 0.25 19.375 0.625V3.125C19.375 3.5 19.125 3.75 18.75 3.75H14.375V11.25C14.375 11.625 14.125 11.875 13.75 11.875Z"
        fill={fill || '#273754'}
      />
      <path
        d="M15.625 5.8125V11.25C15.625 11.625 15.375 11.875 15 11.875C14.625 11.875 14.375 11.625 14.375 11.25V5.625H7.5C10 6.75 10.5625 8.5625 10.5625 10.5625V16.25H18.75C19.125 16.25 19.375 16 19.375 15.625V10.625C19.375 8.3125 17.75 6.375 15.625 5.8125Z"
        fill={fill || '#273754'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.53237 5.68848C8.25 5.68848 10 8.04942 10 10.5346V16.1885H1.64748C1.25899 16.1885 1 15.94 1 15.5672V10.5968C1 8.11155 2.81475 5.68848 5.53237 5.68848ZM3.25024 10C2.83603 10 2.50024 10.3358 2.50024 10.75C2.50024 11.1642 2.83603 11.5 3.25024 11.5H7.75024C8.16446 11.5 8.50024 11.1642 8.50024 10.75C8.50024 10.3358 8.16446 10 7.75024 10H3.25024Z"
        fill={fill || '#273754'}
      />
    </svg>
  )
}
